import { BulletListItem } from '../types';

export function getMarketingBulletsItems(selectedOffer: any): BulletListItem[] {
  if (!selectedOffer || !selectedOffer.marketingBullets) return [];

  const items: BulletListItem[] = selectedOffer.marketingBullets.map(
    (item: any, index: number) => ({
      id: `${index + 1}`,
      text: item,
      fontSize: 16,
    })
  );

  if (selectedOffer.ratesAndFeesCta && selectedOffer.ratesAndFeesCta.link) {
    items.push({
      id: `${items.length + 1}`,
      text: `<a href="${selectedOffer.ratesAndFeesCta.link}">View ${selectedOffer.ratesAndFeesCta.text}</a>`,
      fontSize: 16,
    });
  }

  return items;
}
